(() => {
	const siteName = '';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		setModal() {
			const createModal = (_appendHTML) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
							}, 400);
						});
					});
				});
			};

			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content.outerHTML) {
						let appendHTML = `<div class="mod-modal-closeArea"></div>
							<span class="mod-modal-closeBtn"><span></span></span>
							${$content.outerHTML}`;
						createModal(appendHTML);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<span class="mod-modal-closeBtn"><span class="mod-modal-closeBtn"><span></span></span></span>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML);
				});
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.setModal();
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision());
})();
